<template>
  <div class="stockStatistics column-me">
    <div class="tab-div row-me">
      <div class="item-tab column-me row-center" @click="clickTab(0)">
        <div class="tab-title" :class="{'tab-title-active':tabIndex===0}">入库统计</div>
        <div class="tab-line" :class="{'tab-line-active':tabIndex===0}"></div>
      </div>
      <div class="item-tab column-me row-center" @click="clickTab(1)">
        <div class="tab-title" :class="{'tab-title-active':tabIndex===1}">出库统计</div>
        <div class="tab-line" :class="{'tab-line-active':tabIndex===1}"></div>
      </div>
      <div class="item-tab column-me row-center" @click="clickTab(2)">
        <div class="tab-title" :class="{'tab-title-active':tabIndex===2}">进销存统计</div>
        <div class="tab-line" :class="{'tab-line-active':tabIndex===2}"></div>
      </div>
    </div>

    <!--入库统计-->
    <div class="card-div column-me flex1" v-show="tabIndex===0">
      <div class="row-me row-center">
        <div class="width180">
          <el-date-picker type="date" placeholder="开始时间" value-format="YYYY-MM-DD" style="width: 100%;"
                          v-model="tab1Item.selectDate1" :disabled-date="disabledDate">
          </el-date-picker>
        </div>
        <div class="margin-left10 margin-right10">-</div>
        <div class="width180 margin-right10">
          <el-date-picker type="date" placeholder="结束时间" value-format="YYYY-MM-DD" style="width: 100%;"
                          v-model="tab1Item.selectDate2" :disabled-date="disabledDate">
          </el-date-picker>
        </div>
        <div class="width180 margin-right10">
          <el-input placeholder="搜索药品" style="width: 100%;" clearable v-model="tab1Item.drugName"></el-input>
        </div>
        <div class="width180 margin-right10">
          <el-select placeholder="库房名称" style="width: 100%;" filterable clearable v-model="tab1Item.selectHouse">
            <el-option v-for="item in houseArray" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="width180 margin-right10">
          <el-select placeholder="入库类型" style="width: 100%;" filterable clearable v-model="tab1Item.selectType">
            <el-option v-for="item in typeArrayIn" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="btn-blue width100 btn-height40" @click="clickSearch">
          <el-icon>
            <search/>
          </el-icon>
          查询
        </div>
        <div class="btn-blank width100 btn-height40 margin-left10" @click="clickClear">
          <el-icon>
            <delete/>
          </el-icon>
          清空
        </div>
        <div class="btn-blank width100 btn-height40 margin-left10" @click="clickExport">导出</div>
      </div>
      <div class="margin-top20 flex1 overflow-auto">
        <el-table :data="tab1Item.tableData" border header-cell-class-name="table-header-style"
                  cell-class-name="table-cell-style" height="100%">
          <el-table-column prop="createTime" label="时间" align="center" show-overflow-tooltip
                           width="210"></el-table-column>
          <el-table-column prop="pharmacyName" label="库房名称" align="center" show-overflow-tooltip
                           width="120"></el-table-column>
          <el-table-column prop="typeName" label="入库类型" align="center" show-overflow-tooltip
                           width="120"></el-table-column>
          <el-table-column prop="drugName" label="药品名称" align="center" show-overflow-tooltip
                           width="120"></el-table-column>
          <el-table-column prop="sn" label="药品编码" align="center" show-overflow-tooltip
                           width="120"></el-table-column>
          <el-table-column prop="receiptNo" label="单据编号" align="center" show-overflow-tooltip
                           width="180"></el-table-column>
          <el-table-column prop="batchNo" label="批号" align="center" show-overflow-tooltip
                           width="260"></el-table-column>
          <el-table-column prop="produceTime" label="生产日期" align="center" show-overflow-tooltip
                           width="150"></el-table-column>
          <el-table-column prop="validityTime" label="有效期" align="center" show-overflow-tooltip
                           width="150"></el-table-column>
          <el-table-column prop="producerName" label="生产商" align="center" show-overflow-tooltip
                           width="120"></el-table-column>
          <el-table-column prop="supplierName" label="供应商" align="center" show-overflow-tooltip
                           width="120"></el-table-column>
          <el-table-column prop="spec" label="规格" align="center" show-overflow-tooltip width="120"></el-table-column>
          <el-table-column prop="unitName" label="单位" align="center" show-overflow-tooltip
                           width="120"></el-table-column>
          <el-table-column prop="costPrice" label="成本价" align="center" show-overflow-tooltip
                           width="120"></el-table-column>
          <el-table-column prop="salePrice" label="零售价" align="center" show-overflow-tooltip
                           width="120"></el-table-column>
          <el-table-column prop="nums" label="变更库存" align="center" show-overflow-tooltip
                           width="120"></el-table-column>
          <!--          <el-table-column prop="beforeChangeNum" label="变更前库存" align="center" show-overflow-tooltip-->
          <!--                           width="120"></el-table-column>-->
          <!--          <el-table-column prop="afterChangeNum" label="变更后库存" align="center" show-overflow-tooltip-->
          <!--                           width="120"></el-table-column>-->
          <el-table-column prop="totalCostPrice" label="变更总成本价" align="center" show-overflow-tooltip
                           width="150"></el-table-column>
          <el-table-column prop="totalSalePrice" label="变更总零售价" align="center" show-overflow-tooltip
                           width="150"></el-table-column>
          <el-table-column prop="operator" label="操作人" align="center" show-overflow-tooltip
                           width="120"></el-table-column>
        </el-table>
      </div>
      <div class="margin-top10">
        <el-pagination @current-change="handleCurrentChange1" :current-page.sync="tab1Item.pageNo"
                       layout="total, prev, pager, next, jumper" :total="tab1Item.total">
        </el-pagination>
      </div>
    </div>

    <!--出库统计-->
    <div class="card-div column-me flex1" v-show="tabIndex===1">
      <div class="row-me row-center">
        <div class="width180">
          <el-date-picker type="date" placeholder="开始时间" value-format="YYYY-MM-DD" style="width: 100%;"
                          v-model="tab2Item.selectDate1" :disabled-date="disabledDate">
          </el-date-picker>
        </div>
        <div class="margin-left10 margin-right10">-</div>
        <div class="width180 margin-right10">
          <el-date-picker type="date" placeholder="结束时间" value-format="YYYY-MM-DD" style="width: 100%;"
                          v-model="tab2Item.selectDate2" :disabled-date="disabledDate">
          </el-date-picker>
        </div>
        <div class="width180 margin-right10">
          <el-input placeholder="搜索药品" style="width: 100%;" clearable v-model="tab2Item.drugName"></el-input>
        </div>
        <div class="width180 margin-right10">
          <el-select placeholder="库房名称" style="width: 100%;" filterable clearable v-model="tab2Item.selectHouse">
            <el-option v-for="item in houseArray" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="width180 margin-right10">
          <el-select placeholder="出库类型" style="width: 100%;" filterable clearable v-model="tab2Item.selectType">
            <el-option v-for="item in typeArrayOut" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="btn-blue width100 btn-height40" @click="clickSearch">
          <el-icon>
            <search/>
          </el-icon>
          查询
        </div>
        <div class="btn-blank width100 btn-height40 margin-left10" @click="clickClear">
          <el-icon>
            <delete/>
          </el-icon>
          清空
        </div>
        <div class="btn-blank width100 btn-height40 margin-left10" @click="clickExport">导出</div>
      </div>
      <div class="margin-top20 flex1 overflow-auto">
        <el-table :data="tab2Item.tableData" border header-cell-class-name="table-header-style"
                  cell-class-name="table-cell-style" height="100%">
          <el-table-column prop="createTime" label="时间" align="center" show-overflow-tooltip
                           width="210"></el-table-column>
          <el-table-column prop="pharmacyName" label="库房名称" align="center" show-overflow-tooltip
                           width="120"></el-table-column>
          <el-table-column prop="typeName" label="出库类型" align="center" show-overflow-tooltip
                           width="120"></el-table-column>
          <el-table-column prop="drugName" label="药品名称" align="center" show-overflow-tooltip
                           width="120"></el-table-column>
          <el-table-column prop="receiptNo" label="单据编号" align="center" show-overflow-tooltip
                           width="180"></el-table-column>
          <el-table-column prop="batchNo" label="批号" align="center" show-overflow-tooltip
                           width="260"></el-table-column>
          <el-table-column prop="produceTime" label="生产日期" align="center" show-overflow-tooltip
                           width="150"></el-table-column>
          <el-table-column prop="validityTime" label="有效期" align="center" show-overflow-tooltip
                           width="150"></el-table-column>
          <el-table-column prop="producerName" label="生产商" align="center" show-overflow-tooltip
                           width="120"></el-table-column>
          <el-table-column prop="supplierName" label="供应商" align="center" show-overflow-tooltip
                           width="120"></el-table-column>
          <el-table-column prop="spec" label="规格" align="center" show-overflow-tooltip width="120"></el-table-column>
          <el-table-column prop="unitName" label="单位" align="center" show-overflow-tooltip
                           width="120"></el-table-column>
          <el-table-column prop="costPrice" label="成本价" align="center" show-overflow-tooltip
                           width="120"></el-table-column>
          <el-table-column prop="salePrice" label="零售价" align="center" show-overflow-tooltip
                           width="120"></el-table-column>
          <el-table-column prop="nums" label="变更库存" align="center" show-overflow-tooltip
                           width="120"></el-table-column>
          <!--          <el-table-column prop="beforeChangeNum" label="变更前库存" align="center" show-overflow-tooltip-->
          <!--                           width="120"></el-table-column>-->
          <!--          <el-table-column prop="afterChangeNum" label="变更后库存" align="center" show-overflow-tooltip-->
          <!--                           width="120"></el-table-column>-->
          <el-table-column prop="totalCostPrice" label="变更总成本价" align="center" show-overflow-tooltip
                           width="150"></el-table-column>
          <el-table-column prop="totalSalePrice" label="变更总零售价" align="center" show-overflow-tooltip
                           width="150"></el-table-column>
          <el-table-column prop="operator" label="操作人" align="center" show-overflow-tooltip
                           width="120"></el-table-column>
        </el-table>
      </div>
      <div class="margin-top10">
        <el-pagination @current-change="handleCurrentChange2" :current-page.sync="tab2Item.pageNo"
                       layout="total, prev, pager, next, jumper" :total="tab2Item.total">
        </el-pagination>
      </div>
    </div>

    <!--进销存统计-->
    <div class="card-div column-me flex1" v-show="tabIndex===2">
      <div class="row-me row-center">
        <div class="width180">
          <el-date-picker type="date" placeholder="开始时间" value-format="YYYY-MM-DD" style="width: 100%;"
                          v-model="tab3Item.selectDate1" :disabled-date="disabledDate">
          </el-date-picker>
        </div>
        <div class="margin-left10 margin-right10">-</div>
        <div class="width180 margin-right10">
          <el-date-picker type="date" placeholder="结束时间" value-format="YYYY-MM-DD" style="width: 100%;"
                          v-model="tab3Item.selectDate2" :disabled-date="disabledDate">
          </el-date-picker>
        </div>
        <div class="width180 margin-right10">
          <el-input placeholder="搜索药品" style="width: 100%;" clearable v-model="tab3Item.drugName"></el-input>
        </div>
        <div class="btn-blue width100 btn-height40" @click="clickSearch">
          <el-icon>
            <search/>
          </el-icon>
          查询
        </div>
        <div class="btn-blank width100 btn-height40 margin-left10" @click="clickClear">
          <el-icon>
            <delete/>
          </el-icon>
          清空
        </div>
        <div class="btn-blank width100 btn-height40 margin-left10" @click="clickExport">导出</div>
      </div>
      <div class="margin-top20 flex1 overflow-auto">
        <el-table :data="tab3Item.tableData" border header-cell-class-name="table-header-style"
                  cell-class-name="table-cell-style" height="100%" show-summary :summary-method="getSummaries">
          <el-table-column prop="name" label="药品名称" align="center" show-overflow-tooltip
                           width="120"></el-table-column>
          <el-table-column prop="spec" label="规格" align="center" show-overflow-tooltip
                           width="120"></el-table-column>
          <el-table-column prop="pharmacyName" label="库房名称" align="center" show-overflow-tooltip
                           width="120"></el-table-column>
          <el-table-column prop="batchNo" label="批号" align="center" show-overflow-tooltip
                           width="260"></el-table-column>
          <el-table-column prop="producerName" label="生产商" align="center" show-overflow-tooltip
                           width="120"></el-table-column>
          <el-table-column label="期初" align="center">
            <el-table-column property="beginningNums" label="数量" align="center" width="100"
                             show-overflow-tooltip></el-table-column>
            <el-table-column property="beginningCost" label="成本" align="center" width="100"
                             show-overflow-tooltip></el-table-column>
            <el-table-column property="beginningAmount" label="金额" align="center"
                             width="100" show-overflow-tooltip></el-table-column>
          </el-table-column>
          <el-table-column label="入库" align="center">
            <el-table-column property="inStorageNums" label="数量" align="center" width="100"
                             show-overflow-tooltip></el-table-column>
            <el-table-column property="inStorageCost" label="成本" align="center" width="100"
                             show-overflow-tooltip></el-table-column>
            <el-table-column property="inStorageAmount" label="金额" align="center"
                             width="100" show-overflow-tooltip></el-table-column>
          </el-table-column>
          <el-table-column label="出库" align="center">
            <el-table-column property="outStorageNums" label="数量" align="center"
                             width="100" show-overflow-tooltip></el-table-column>
            <el-table-column property="outStorageCost" label="成本" align="center"
                             width="100" show-overflow-tooltip></el-table-column>
            <el-table-column property="outStorageAmount" label="金额" align="center"
                             width="100" show-overflow-tooltip></el-table-column>
          </el-table-column>
          <el-table-column label="退药入库" align="center">
            <el-table-column property="retStorageNums" label="数量" align="center"
                             width="100" show-overflow-tooltip></el-table-column>
            <el-table-column property="retStorageCost" label="成本" align="center"
                             width="100" show-overflow-tooltip></el-table-column>
            <el-table-column property="retStorageTotalCost" label="金额" align="center"
                             width="100" show-overflow-tooltip></el-table-column>
            <el-table-column property="retStorageSale" label="售价" align="center"
                             width="100" show-overflow-tooltip></el-table-column>
            <el-table-column property="retStorageTotalSale" label="金额" align="center"
                             width="100" show-overflow-tooltip></el-table-column>
          </el-table-column>
          <el-table-column label="发药出库" align="center">
            <el-table-column property="sendStorageNums" label="数量" align="center"
                             width="100" show-overflow-tooltip></el-table-column>
            <el-table-column property="sendStorageCost" label="成本" align="center"
                             width="100" show-overflow-tooltip></el-table-column>
            <el-table-column property="sendStorageTotalCost" label="金额" align="center"
                             width="100" show-overflow-tooltip></el-table-column>
            <el-table-column property="sendStorageSale" label="售价" align="center"
                             width="100" show-overflow-tooltip></el-table-column>
            <el-table-column property="sendStorageTotalSale" label="金额" align="center"
                             width="100" show-overflow-tooltip></el-table-column>
          </el-table-column>
          <el-table-column label="盘点盈亏" align="center">
            <el-table-column property="panStorageNums" label="数量" align="center" width="100"
                             show-overflow-tooltip></el-table-column>
            <el-table-column property="panStorageCost" label="成本" align="center" width="100"
                             show-overflow-tooltip></el-table-column>
            <el-table-column property="panStorageTotalCost" label="金额" align="center" width="100"
                             show-overflow-tooltip></el-table-column>
          </el-table-column>
          <el-table-column label="期末" align="center">
            <el-table-column property="endNums" label="数量" align="center" width="100"
                             show-overflow-tooltip></el-table-column>
            <el-table-column property="endCost" label="成本" align="center" width="100"
                             show-overflow-tooltip></el-table-column>
            <el-table-column property="endAmount" label="金额" align="center" width="100"
                             show-overflow-tooltip></el-table-column>
          </el-table-column>
        </el-table>
      </div>
      <div class="margin-top10">
        <el-pagination @current-change="handleCurrentChange3" :current-page.sync="tab3Item.pageNo"
                       layout="total, prev, pager, next, jumper" :total="tab3Item.total">
        </el-pagination>
      </div>
    </div>

  </div>
</template>

<script>

export default {
  components: {},
  data() {
    let that = this
    return {
      tabIndex: 0,
      houseArray: [],
      typeArrayIn: [],
      typeArrayOut: [],
      drugTypeArray: [],//药品分类
      tab1Item: {
        selectDate1: '',
        selectDate2: '',
        drugName: '',
        selectHouse: '',
        selectType: '',
        tableData: [],
        pageNo: 1,
        total: 0,
      },
      tab2Item: {
        selectDate1: '',
        selectDate2: '',
        drugName: '',
        selectHouse: '',
        selectType: '',
        tableData: [],
        pageNo: 1,
        total: 0,
      },
      tab3Item: {
        selectDate1: '',
        selectDate2: '',
        drugName: '',
        tableData: [],
        pageNo: 1,
        total: 0,
        summary: {},//合计
      },
      disabledDate: function (time) {
        return time.getTime() > new Date(that.$method.getNowTime()).getTime();
      },
    }
  },
  // html加载完成之前
  created() {
    this.getHouseArray()
    this.getInStorageType()
    this.tab1Item.selectDate1 = this.$method.getNowDate()
    this.tab1Item.selectDate2 = this.$method.getNowDate()
    this.tab2Item.selectDate1 = this.$method.getNowDate()
    this.tab2Item.selectDate2 = this.$method.getNowDate()
    this.tab3Item.selectDate1 = this.$method.getNowDate()
    this.tab3Item.selectDate2 = this.$method.getNowDate()
  },
  // html加载完成后执行。
  mounted() {
    this.clickSearch()
  },
  // 事件方法执行
  methods: {
    //获取数据
    getData() {
      if (this.tabIndex === 0) {
        this.$postFormRequest('/admin/statistics/inventoryReceipt', {
          start: this.tab1Item.selectDate1,
          end: this.tab1Item.selectDate2,
          drugName: this.tab1Item.drugName,
          pharmacyId: this.tab1Item.selectHouse,
          type: this.tab1Item.selectType,
          pageNumber: this.tab1Item.pageNo,
        }).then((res) => {
          if (res) {
            this.tab1Item.tableData = res.data.list
            this.tab1Item.total = res.data.totalRow
          }
        }).catch((error) => {
          console.log(error)
        })
      } else if (this.tabIndex === 1) {
        this.$postFormRequest('/admin/statistics/inventoryOutReceipt', {
          start: this.tab2Item.selectDate1,
          end: this.tab2Item.selectDate2,
          drugName: this.tab2Item.drugName,
          pharmacyId: this.tab2Item.selectHouse,
          type: this.tab2Item.selectType,
          pageNumber: this.tab2Item.pageNo,
        }).then((res) => {
          if (res) {
            this.tab2Item.tableData = res.data.list
            this.tab2Item.total = res.data.totalRow
          }
        }).catch((error) => {
          console.log(error)
        })
      } else if (this.tabIndex === 2) {
        this.$postFormRequest('/admin/statistics/pinToSave', {
          startDate: this.tab3Item.selectDate1,
          endDate: this.tab3Item.selectDate2,
          name: this.tab3Item.drugName,
          pageNumber: this.tab3Item.pageNo,
        }).then((res) => {
          if (res) {
            this.tab3Item.tableData = res.data.list
            this.tab3Item.total = res.data.totalRow
            this.tab3Item.summary = res.data1
          }
        }).catch((error) => {
          console.log(error)
        })
      }
    },
    clickTab(index) {
      this.tabIndex = index
      this.clickSearch()
    },
    clickSearch() {
      if (this.tabIndex === 0) {
        if (this.tab1Item.selectDate1 > this.tab1Item.selectDate2) {
          this.$message.error('开始时间不能大于结束时间')
          return
        }
        this.tab1Item.pageNo = 1
        this.getInStorageType()
      } else if (this.tabIndex === 1) {
        if (this.tab2Item.selectDate1 > this.tab2Item.selectDate2) {
          this.$message.error('开始时间不能大于结束时间')
          return
        }
        this.tab2Item.pageNo = 1
        this.getOutStorageType()
      } else if (this.tabIndex === 2) {
        if (this.tab3Item.selectDate1 > this.tab3Item.selectDate2) {
          this.$message.error('开始时间不能大于结束时间')
          return
        }
        this.tab3Item.pageNo = 1
      }
      this.getData()
    },
    clickClear() {
      if (this.tabIndex === 0) {
        this.tab1Item.selectDate1 = this.$method.getNowDate()
        this.tab1Item.selectDate2 = this.$method.getNowDate()
        this.tab1Item.drugName = ''
        this.tab1Item.selectHouse = ''
        this.tab1Item.selectType = ''
      } else if (this.tabIndex === 1) {
        this.tab2Item.selectDate1 = this.$method.getNowDate()
        this.tab2Item.selectDate2 = this.$method.getNowDate()
        this.tab2Item.drugName = ''
        this.tab2Item.selectHouse = ''
        this.tab2Item.selectType = ''
      } else if (this.tabIndex === 2) {
        this.tab3Item.selectDate1 = this.$method.getNowDate()
        this.tab3Item.selectDate2 = this.$method.getNowDate()
        this.tab3Item.drugName = ''
      }
      this.clickSearch()
    },
    clickExport() {
      if (this.tabIndex === 0) {
        let token = sessionStorage.getItem('token')
        let param = {
          start: this.tab1Item.selectDate1,
          end: this.tab1Item.selectDate2,
          drugName: this.tab1Item.drugName,
          pharmacyId: this.tab1Item.selectHouse,
          type: this.tab1Item.selectType,
          pageNumber: this.tab1Item.pageNo,
          token: token,
        }
        let url = this.$baseUrl + '/admin/statistics/inventoryExport?' + this.$method.getParamsString(param)
        window.open(url)
      } else if (this.tabIndex === 1) {
        let token = sessionStorage.getItem('token')
        let param = {
          start: this.tab2Item.selectDate1,
          end: this.tab2Item.selectDate2,
          drugName: this.tab2Item.drugName,
          pharmacyId: this.tab2Item.selectHouse,
          type: this.tab2Item.selectType,
          pageNumber: this.tab2Item.pageNo,
          token: token,
        }
        let url = this.$baseUrl + '/admin/statistics/inventoryOutExport?' + this.$method.getParamsString(param)
        window.open(url)
      } else if (this.tabIndex === 2) {
        let token = sessionStorage.getItem('token')
        let param = {
          startDate: this.tab3Item.selectDate1,
          endDate: this.tab3Item.selectDate2,
          name: this.tab3Item.drugName,
          pageNumber: this.tab3Item.pageNo,
          token: token,
        }
        let url = this.$baseUrl + '/admin/statistics/pinToSaveExport?' + this.$method.getParamsString(param)
        window.open(url)
      }
    },
    //页数改变
    handleCurrentChange1(pageNo) {
      this.tab1Item.pageNo = pageNo
      this.getData()
    },
    handleCurrentChange2(pageNo) {
      this.tab2Item.pageNo = pageNo
      this.getData()
    },
    handleCurrentChange3(pageNo) {
      this.tab3Item.pageNo = pageNo
      this.getData()
    },
    //进销存合计
    getSummaries(param) {
      const {columns, data} = param;
      const sums = [];
      columns.forEach((column, index) => {
        let blankIndex = 5
        if (index === 0) {
          sums[index] = '总计';
        } else if (index === blankIndex) {
          sums[index] = this.tab3Item.summary.beginningNums;
        } else if (index === blankIndex + 1) {
          sums[index] = this.tab3Item.summary.beginningCost;
        } else if (index === blankIndex + 2) {
          sums[index] = this.tab3Item.summary.beginningAmount;
        } else if (index === blankIndex + 3) {
          sums[index] = this.tab3Item.summary.inStorageNums;
        } else if (index === blankIndex + 4) {
          sums[index] = this.tab3Item.summary.inStorageCost;
        } else if (index === blankIndex + 5) {
          sums[index] = this.tab3Item.summary.inStorageAmount;
        } else if (index === blankIndex + 6) {
          sums[index] = this.tab3Item.summary.outStorageNums;
        } else if (index === blankIndex + 7) {
          sums[index] = this.tab3Item.summary.outStorageCost;
        } else if (index === blankIndex + 8) {
          sums[index] = this.tab3Item.summary.outStorageAmount;
        } else if (index === blankIndex + 9) {
          sums[index] = this.tab3Item.summary.retStorageNums;
        } else if (index === blankIndex + 10) {
          sums[index] = this.tab3Item.summary.retStorageCost;
        } else if (index === blankIndex + 11) {
          sums[index] = this.tab3Item.summary.retStorageTotalCost;
        } else if (index === blankIndex + 12) {
          sums[index] = this.tab3Item.summary.retStorageSale;
        } else if (index === blankIndex + 13) {
          sums[index] = this.tab3Item.summary.retStorageTotalSale;
        } else if (index === blankIndex + 14) {
          sums[index] = this.tab3Item.summary.sendStorageNums;
        } else if (index === blankIndex + 15) {
          sums[index] = this.tab3Item.summary.sendStorageCost;
        } else if (index === blankIndex + 16) {
          sums[index] = this.tab3Item.summary.sendStorageTotalCost;
        } else if (index === blankIndex + 17) {
          sums[index] = this.tab3Item.summary.sendStorageSale;
        } else if (index === blankIndex + 18) {
          sums[index] = this.tab3Item.summary.sendStorageTotalSale;
        } else if (index === blankIndex + 19) {
          sums[index] = this.tab3Item.summary.panStorageNums;
        } else if (index === blankIndex + 20) {
          sums[index] = this.tab3Item.summary.panStorageCost;
        } else if (index === blankIndex + 21) {
          sums[index] = this.tab3Item.summary.panStorageTotalCost;
        } else if (index === blankIndex + 22) {
          sums[index] = this.tab3Item.summary.endNums;
        } else if (index === blankIndex + 23) {
          sums[index] = this.tab3Item.summary.endCost;
        } else if (index === blankIndex + 24) {
          sums[index] = this.tab3Item.summary.endAmount;
        }
      });
      return sums;
    },
    //获取库房
    getHouseArray() {
      this.$getRequest('/admin/pharmacy/listAll', {}).then((res) => {
        if (res) {
          this.houseArray = res.data
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //获取入库类型
    getInStorageType() {
      this.$getRequest('/admin/dict/getInStorageType', {}).then((res) => {
        if (res) {
          this.typeArrayIn = res.data
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //获取出库类型
    getOutStorageType() {
      this.$getRequest('/admin/dict/getOutStorageType', {}).then((res) => {
        if (res) {
          this.typeArrayOut = res.data
        }
      }).catch((error) => {
        console.log(error)
      })
    },
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {},
}
</script>

<style lang="scss" scoped>
.stockStatistics {
  height: 100%;

  .tab-div {
    height: 60px;
    background: #FFFFFF;
    margin: 20px 20px 0 20px;
    padding-left: 20px;

    .item-tab {
      height: 60px;
      justify-content: flex-end;
      margin-right: 50px;

      .tab-title {
        font-size: 18px;
        color: #252630;

        &-active {
          color: #215AA0;
        }
      }

      .tab-line {
        width: 20px;
        height: 4px;
        background: #FFFFFF;
        border-radius: 1px;

        &-active {
          background: #215AA0;
        }
      }
    }
  }

  .card-div {
    margin: 20px;
    background: #FFFFFF;
    box-shadow: 0 0 5px #F3F3F3;
    border-radius: 3px;
    padding: 20px;
    font-size: 18px;
    color: #252630;
    overflow: auto;
  }
}
</style>
